var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { "data-qa": "backing-information" } },
    [
      _c("div", { staticClass: "_mb-2 gfu-project-banner__field-label" }, [
        _vm._v(
          _vm._s(
            _vm.Resources.ProjectHome.ProjectStoryBackingInformationSectionLabel
          )
        ),
      ]),
      _vm._v(" "),
      _c("backing-information-list", {
        attrs: { items: _vm.mappedBackingInformationItems },
        on: { select: _vm.onSelect },
      }),
      _vm._v(" "),
      _vm.isModalOpen
        ? _c(
            "backing-information-modal",
            _vm._b(
              {
                attrs: {
                  "current-key": _vm.selectedKey,
                  "is-stretch-pay-enabled": _vm.isStretchPayEnabled,
                  "is-stable-pledge-enabled": _vm.isStablePledgeEnabled,
                  "is-crowdfunding-risks-enabled":
                    _vm.isCrowdfundingRisksEnabled,
                },
                on: { close: _vm.onClose, select: _vm.onSelect },
              },
              "backing-information-modal",
              _vm.currentModalProps,
              false
            )
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }